module.exports = __webpack_public_path__ + "static/media/Veronica Meuris.1e2918bd.png";